/**
 * 互助类型
 */
 export const helptype: Array<any> = [
    { 'id': '1', name: '产检陪护' },
    { 'id': '2', name: '小孩托管' },
    { 'id': '3', name: '作业辅导' },
];
